module.exports = __webpack_public_path__ + "static/img/m-sp.1f31f29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/m-sp.png
// module id = fPGh
// module chunks = 0